import React, { useState, useEffect, useRef } from 'react';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';


export default function DisplaySetor(props){
    

function hexToTextSafe(input) {

    if (!input) return '';

    if (typeof input !== 'string') {
        input = String(input);
    }

    const clean = input.replace(/\s+/g, '');

    const isHex = /^[0-9A-Fa-f]+$/.test(clean) && clean.length % 2 === 0;

    if (!isHex) {
        return input.toUpperCase();
    }

    let result = '';
    for (let i = 0; i < clean.length; i += 2) {
        result += String.fromCharCode(parseInt(clean.substr(i, 2), 16));
    }

    return result.toUpperCase();
}

return <span style={{fontSize:'9px'}}>
        Setor:
        <strong>
    {
        props.setor 
        ? 
        props.setor
        :
        hexToTextSafe(props.syslocation)
    
    }
    </strong>
</span>

}